"use client";

import { TokenCreateForm } from "@/components/token-create/TokenCreateForm";

/** Shared step-2 token details form (Revive create + IDX Launchlab create step 1). */
export function CreateTokenFormStep({
  resetKey = 0,
  newToken,
  updateNewToken,
  nameFieldLabel,
  nameFieldPlaceholder,
  imageFieldLabel,
  assetNoun,
  showBannerDescription,
  symbolMaxLength,
}) {
  return (
    <TokenCreateForm
      resetKey={resetKey}
      newToken={newToken}
      updateNewToken={updateNewToken}
      nameFieldLabel={nameFieldLabel}
      nameFieldPlaceholder={nameFieldPlaceholder}
      imageFieldLabel={imageFieldLabel}
      assetNoun={assetNoun}
      showBannerDescription={showBannerDescription}
      symbolMaxLength={symbolMaxLength}
    />
  );
}
